import React from 'react';
import { Accordion, Box, TextFieldForm } from 'web-library';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ContactNumberFormItem } from '../../../../components/form-items/ContactNumberFormItem';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';

import {
  CandidateProfileFormData,
  CandidateProfileFormDefaultValues,
  CandidateProfileIsDisableInputs,
} from '../../../../models';
import { useStyles } from './styles';
import ToggleDisplayEditFormItem from '../../../../components/ToggleDisplayEditFormItem';
import {
  DROPDOWN_PLACEHOLDER,
  getIExamDropdownItemLabel,
  getIExamMasterCodeSelected,
} from '../../logic/useCandidateProfileForm';
import { fallbackDashString } from '../../../../utils/StringUtils';
import { getContactDisplayValue } from '../../../../utils/ComponentUtils';
import { useGetIExamMasterCode } from '../../../../api-refactored/user/useGetIExamMasterCode';
import {IExamMasterCodeItem} from "../../../../api/user/model";

interface CandidateProfileEmergencyContactsProps {
  isEditState: boolean;
  formHook: UseFormReturn<CandidateProfileFormData>;
  isDisableInputs?: CandidateProfileIsDisableInputs;
  formDefaultValues?: CandidateProfileFormDefaultValues;
  formDefaultValuesViewDetails?: CandidateProfileFormDefaultValues;
  isView: boolean;
}

const CandidateProfileEmergencyContacts = ({
  isEditState,
  formHook,
  isDisableInputs = undefined,
  formDefaultValues = undefined,
  formDefaultValuesViewDetails = undefined,
  isView,
}: CandidateProfileEmergencyContactsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { control, register, formState: { errors } } = formHook;

  const {
    data: dataIEXAM,
    isLoading: isLoadingIEXAM,
    error: errorMasterCode,
    refetch: refetchMasterCode,
  } = useGetIExamMasterCode();

  return (
    <Accordion
      defaultExpanded
      header={t('profile->>CreateCandidateForm.NextOfKinDetails')}
      bottomLine={isView}
    >
      <Box className={classes.responsiveFlexContainer}>
        <ToggleDisplayEditFormItem
          id="input-nextOfKinName"
          isEditState={isEditState}
          labelText={t('profile->>CreateCandidateForm.EmergencyContactName')}
          valueText={fallbackDashString(formDefaultValuesViewDetails?.nextOfKinName)}
          containerClassName={classes.formElementContainer}
          EditComponent={
            <TextFieldForm
                form={formHook}
              isInputTextUpperCase
              onChange={(e) => formHook?.setValue('nextOfKinName', e.target.value.toUpperCase())}
              label={t('profile->>CreateCandidateForm.EmergencyContactName')}
              name="nextOfKinName"
              id="input-nextOfKinName"
              type="text"
              error={!!errors.nextOfKinName}
              helperText={errors?.nextOfKinName?.message?.toString()}
              fullWidth
              InputProps={{ readOnly: isDisableInputs?.nextOfKinName }}
              isRequired
            />
          }
        />

        <ToggleDisplayEditFormItem
          isEditState={isEditState}
          labelText={t('profile->>CreateCandidateForm.Relationship to Candidate')}
          valueText={fallbackDashString(
            formDefaultValuesViewDetails?.nextOfKinRelationshipToCandidate?.codeValueDescription
          )}
          id="input-select-nextOfKinRelationshipToCandidate"
          containerClassName={classes.formElementContainer}
          EditComponent={
            <ControlledAutocomplete<IExamMasterCodeItem, false, false, undefined>
              label={t('profile->>CreateCandidateForm.Relationship to Candidate')}
              control={control}
              name="nextOfKinRelationshipToCandidate"
              id="input-select-nextOfKinRelationshipToCandidate"
              error={!!errors.nextOfKinRelationshipToCandidate}
              helperText={errors?.nextOfKinRelationshipToCandidate?.message?.toString()}
              loading={isLoadingIEXAM}
              loadingError={!!errorMasterCode}
              loadingErrorOnReFetch={refetchMasterCode}
              options={dataIEXAM ? dataIEXAM.relationship : []}
              getOptionLabel={getIExamDropdownItemLabel}
              placeholder={DROPDOWN_PLACEHOLDER}
              disabled={isDisableInputs?.nextOfKinRelationshipToCandidate}
              isOptionEqualToValue={getIExamMasterCodeSelected}
              isRequired
            />
          }
        />

        <ToggleDisplayEditFormItem
          isEditState={isEditState}
          labelText={t('profile->>CreateCandidateForm.Emergency Contact No.')}
          valueText={getContactDisplayValue(
            false,
            formDefaultValuesViewDetails?.nextOfKinCountryCode?.codeValueDescription,
            formDefaultValuesViewDetails?.nextOfKinContactNumber
          )}
          containerClassName={classes.formElementContainer}
          id="nextOfKinCountryCode"
          EditComponent={
            <ContactNumberFormItem
              id="nextOfKinCountryCode"
              formHook={formHook}
              label={t('profile->>CreateCandidateForm.Emergency Contact No.')}
              countryCode={{
                name: 'nextOfKinCountryCode',
                error: !!errors.nextOfKinCountryCode,
                helperText: errors?.nextOfKinCountryCode?.message?.toString(),
                disabled: isDisableInputs?.nextOfKinCountryCode,
              }}
              countryCodeisOptionEqualToValue={getIExamMasterCodeSelected}
              number={{
                name: 'nextOfKinContactNumber',
                error: !!errors.nextOfKinContactNumber,
                helperText: errors?.nextOfKinContactNumber?.message?.toString(),
                disabled: isDisableInputs?.nextOfKinContactNumber,
              }}
              isSkipTransform
              placeholder="Enter Emergency Contact No."
              isRequired
            />
          }
        />
      </Box>
    </Accordion>
  );
};

export default CandidateProfileEmergencyContacts;
